import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22.0306 7.28104L10.0306 19.281C9.9609 19.3508 9.87818 19.4061 9.78713 19.4438C9.69609 19.4816 9.59849 19.501 9.49993 19.501C9.40137 19.501 9.30377 19.4816 9.21272 19.4438C9.12168 19.4061 9.03896 19.3508 8.9693 19.281L3.7193 14.031C3.57857 13.8903 3.49951 13.6994 3.49951 13.5004C3.49951 13.3014 3.57857 13.1105 3.7193 12.9698C3.86003 12.8291 4.05091 12.75 4.24993 12.75C4.44895 12.75 4.63982 12.8291 4.78055 12.9698L9.49993 17.6901L20.9693 6.21979C21.11 6.07906 21.3009 6 21.4999 6C21.699 6 21.8898 6.07906 22.0306 6.21979C22.1713 6.36052 22.2503 6.55139 22.2503 6.75042C22.2503 6.94944 22.1713 7.14031 22.0306 7.28104Z",
		fill: "current"
	})
});
export default SvgCheck;
